import { IconCheckmark, IconCopy, Spot, Stack, Text, useNotification } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import { formatIban } from '@/shared/helpers'
import styles from './IbanCopy.module.css'

type IbanCopyProps = {
  iban: string
}

const IbanCopy = ({ iban }: IbanCopyProps) => {
  const { t } = useTranslation()
  const { notify } = useNotification()

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(iban)
    } catch {
      return
    }
    notify({
      icon: (
        <Spot color='teal'>
          <IconCheckmark />
        </Spot>
      ),
      title: t('user.iban.copied'),
    })
  }

  return (
    <button
      type='button'
      onClick={handleCopy}
      className={styles.copyButton}
      aria-label={t('user.iban.copyLabel')}
    >
      <Stack direction='horizontal' space='4' align='center'>
        <Text color='neutral-alternate'>{formatIban(iban)}</Text>
        <IconCopy color='neutral-alternate' accent='teal' />
      </Stack>
    </button>
  )
}

export default IbanCopy
